"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormFieldHighlighting = void 0;
const react_1 = __importStar(require("react"));
const colors_1 = require("@material-ui/core/colors");
const styles_1 = require("@material-ui/core/styles");
const detail_context_1 = require("../composite/detail/detail-context");
const detail_types_1 = require("../composite/detail/detail-types");
const evidence_context_1 = require("../composite/evidence/evidence-context");
const useStyles = (0, styles_1.makeStyles)({
    highlighted: {
        backgroundColor: colors_1.yellow[500],
    },
});
function useFormFieldHighlighting({ enableHighlighting, fieldName, value, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const classes = useStyles();
    const detailContext = (0, react_1.useContext)(detail_context_1.DetailContext);
    const tableContext = (0, react_1.useContext)(evidence_context_1.EvidenceContext);
    if (!enableHighlighting || !fieldName || !value || !tableContext) {
        return { showHighlightedComponent: false, highlightedContent: null };
    }
    const parser = new DOMParser();
    const itemFragments = (_d = (_c = (_b = (_a = tableContext.tableSource) === null || _a === void 0 ? void 0 : _a.highlights) === null || _b === void 0 ? void 0 : _b.find((highlight) => { var _a, _b; return highlight.id === ((_b = (_a = detailContext === null || detailContext === void 0 ? void 0 : detailContext.source) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id); })) === null || _c === void 0 ? void 0 : _c.fragments) !== null && _d !== void 0 ? _d : {};
    const fieldHighlights = (_f = (_e = Object.entries(itemFragments).find(([key, _]) => key.includes(fieldName))) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : [];
    const indexes = fieldHighlights.map((highlight) => {
        var _a;
        const withoutTags = highlight
            .replaceAll('<em>', '')
            .replaceAll('</em>', '');
        const firstIndex = (_a = (value.indexOf(withoutTags) !== -1 ? value.indexOf(withoutTags) : 0)) !== null && _a !== void 0 ? _a : 0;
        return {
            firstIndex: firstIndex,
            lastIndex: firstIndex + withoutTags.length,
        };
    });
    const highlightedContent = (react_1.default.createElement(react_1.default.Fragment, null,
        ((_g = indexes[0]) === null || _g === void 0 ? void 0 : _g.firstIndex) !== 0
            ? value.slice(0, (_h = indexes[0]) === null || _h === void 0 ? void 0 : _h.firstIndex)
            : '', fieldHighlights === null || fieldHighlights === void 0 ? void 0 :
        fieldHighlights.map((highlight, idx) => {
            var _a, _b, _c;
            const replacedTags = parser.parseFromString(highlight
                .replaceAll('<em>', `<span class=${classes.highlighted}>`)
                .replaceAll('</em>', '</span>'), 'text/html').body.innerHTML;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                value.slice((_a = indexes[idx]) === null || _a === void 0 ? void 0 : _a.firstIndex, (_b = indexes[idx]) === null || _b === void 0 ? void 0 : _b.firstIndex),
                react_1.default.createElement("span", { key: idx, dangerouslySetInnerHTML: { __html: replacedTags } }),
                value.slice(indexes[idx].lastIndex, (_c = indexes[idx + 1]) === null || _c === void 0 ? void 0 : _c.firstIndex)));
        })));
    const showHighlightedComponent = (detailContext === null || detailContext === void 0 ? void 0 : detailContext.mode) === detail_types_1.DetailMode.VIEW && (fieldHighlights === null || fieldHighlights === void 0 ? void 0 : fieldHighlights.length) > 0;
    return { showHighlightedComponent, highlightedContent };
}
exports.useFormFieldHighlighting = useFormFieldHighlighting;
//# sourceMappingURL=field-highlighting-hook.js.map